import React from 'react';
import { PAD, Reveal, SlideFrame, SlideHeader, t } from './primitives';
const BRANDS = [{
  brand: 'LEO Pharma CHE',
  campaigns: ['Website Snak video embeds across chapters']
}, {
  brand: 'DERMX',
  campaigns: ['Webinar series — Leo Pharma UK']
}, {
  brand: 'Travocort® & Travogen®',
  campaigns: ['Brand campaign, tranche 1', 'Brand campaign, tranche 2']
}, {
  brand: 'TraloSpeak — KEE webinar series',
  campaigns: ['Master slide transformation', 'Treasure chest Snak bundle', 'Snak localization bundle']
}, {
  brand: 'ANZUPGO®',
  campaigns: ['Original campaign', 'UK content creation & website snackification', 'Patient campaign, Spain']
}, {
  brand: 'Protopic® & Fusidin®',
  campaigns: ['New product launch for affiliates']
}];
const ACTIVE_MARKETS = ['Denmark', 'UK', 'Switzerland', 'Spain', 'Germany'];
const PLANNED_MARKETS = ['Italy', 'France', 'Netherlands', 'Czech Republic', 'Brazil'];
const FACTS = [{
  value: '9',
  label: 'Active brands'
}, {
  value: '10+',
  label: 'Countries'
}, {
  value: '12',
  label: 'Campaigns in flight'
}, {
  value: '25',
  label: 'Planned localizations (5 masters × 5 markets)'
}];
export function LeoLandscape() {
  return <SlideFrame data-id="element-142" data-mp="3jowc09t6wbt8">
      <div className={`flex h-full w-full flex-col ${PAD}`} data-id="element-143" data-mp="3joejno9nehql">
        <SlideHeader eyebrow="04 — Account landscape" title="Brands, campaigns and markets" accent="already in play" kicker="Snakker for LEO Pharma" data-id="element-144" data-mp="3jr0qtmsmmv8a" />

        <div className="mt-[2.6vh] grid min-h-0 flex-1 grid-cols-[1.5fr_1fr] gap-[1.4vw]" data-id="element-145" data-mp="3sni1yq0zqt41">
          <div className="flex min-h-0 flex-col gap-[1.1vh]" data-id="element-146" data-mp="baxf95ye8meo">
            <div className="grid min-h-0 flex-1 grid-cols-2 gap-[1.1vw]" data-id="element-147" data-mp="6b2qp923c8ws">
              {BRANDS.map((item, index) => <Reveal key={item.brand} delay={0.2 + index * 0.06} className="flex min-h-0" data-id="element-148" data-mp="k9smmld6c2jk" data-mpi={index}>
                  <div className="flex w-full flex-col justify-center rounded-[0.6vw] border border-white/10 bg-white/[0.035] px-[1.2vw] py-[1.2vh]" data-id="element-149" data-mp="393h34v4mgcjz">
                    <p className={`${t.body} font-semibold leading-[1.15] text-white`} data-id="element-150" data-mp="3dz4rj8ba51of">
                      {item.brand}
                    </p>
                    <ul className="mt-[0.8vh] flex flex-col gap-[0.4vh]" data-id="element-151" data-mp="3mvxc0ck7f4st">
                      {item.campaigns.map(campaign => <li key={campaign} className={`${t.label} flex gap-[0.6vw] leading-[1.3] text-white/55`} data-id="element-152" data-mp="m33dmtff4kd">
                          <span aria-hidden className="mt-[0.6em] h-[2px] w-[0.8vw] shrink-0 bg-[#7D38E5]" data-id="element-153" data-mp="9n0yfflw01qt" />
                          <span data-id="element-154" data-mp="2bentbs8wggsk">{campaign}</span>
                        </li>)}
                    </ul>
                  </div>
                </Reveal>)}
            </div>

            <Reveal delay={0.6} className="shrink-0" data-id="element-155" data-mp="1z4oeklrywf8t">
              <div className="flex items-baseline gap-[1.2vw] rounded-[0.6vw] border border-white/10 bg-white/[0.02] px-[1.2vw] py-[1.2vh]" data-id="element-156" data-mp="1z2v22puob0sw">
                <span className={`${t.label} shrink-0 font-semibold uppercase tracking-[0.18em] text-[#A26BFF]`} data-id="element-157" data-mp="1q3zyllj0k4ta">
                  Also in flight
                </span>
                <p className={`${t.label} leading-[1.35] text-white/60`} data-id="element-158" data-mp="2hv5t9mfytab6">
                  Skinoren · Advantan · Ensuko (video & IVA content) · Zip Code
                  clinician content, deployed in 3 markets and adapted for patients in
                  Spain
                </p>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.35} className="flex min-h-0" data-id="element-159" data-mp="12exapvxsdfqc">
            <div className="flex min-h-0 w-full flex-col rounded-[0.8vw] border border-white/10 bg-white/[0.035] p-[1.35vw]" data-id="element-160" data-mp="xfc7387o8j7a">
              <h3 className={`${t.label} shrink-0 font-semibold uppercase tracking-[0.18em] text-white/70`} data-id="element-161" data-mp="2lapghoyk1nc1">
                Countries & regions
              </h3>

              <div className="mt-[2vh] min-h-0 flex-1" data-id="element-162" data-mp="2cc3rbaykva2a">
                <p className={`${t.label} text-white/45`} data-id="element-163" data-mp="2gcnmwa3i65mb">Active campaigns</p>
                <div className="mt-[1.1vh] flex flex-wrap gap-[0.5vw]" data-id="element-164" data-mp="2gcxhyc3en2yv">
                  {ACTIVE_MARKETS.map(market => <span key={market} className={`${t.small} rounded-full bg-[#7D38E5] px-[1vw] py-[0.7vh] font-medium text-white`} data-id="element-165" data-mp="391cosbcduez4">
                      {market}
                    </span>)}
                </div>

                <p className={`${t.label} mt-[2.4vh] text-white/45`} data-id="element-166" data-mp="1jmep4ua4t3z3">
                  Planned localization & interest
                </p>
                <div className="mt-[1.1vh] flex flex-wrap gap-[0.5vw]" data-id="element-167" data-mp="1omj9ive5uiul">
                  {PLANNED_MARKETS.map(market => <span key={market} className={`${t.small} rounded-full border border-[#7D38E5]/60 px-[1vw] py-[0.7vh] text-white/75`} data-id="element-168" data-mp="1g2o1fz19tkdx">
                      {market}
                    </span>)}
                </div>
              </div>

              <div className="mt-[1.6vh] shrink-0 border-t border-white/10 pt-[1.6vh]" data-id="element-169" data-mp="xdzgxe6p9h2o">
                <p className={`${t.label} leading-[1.4] text-white/60`} data-id="element-170" data-mp="xbn2hb05houd">
                  CHE localization plan: Germany and Italy pilot the embedded Snak
                  website in Mar–Apr 2026, with UK, Spain, France and the Netherlands
                  following.
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.68} className="mt-[2.4vh] grid shrink-0 grid-cols-4 gap-[1.4vw] border-t border-white/10 pt-[2.2vh]" data-id="element-171" data-mp="em70skcqbqcd">
          {FACTS.map(fact => <div key={fact.label} className="flex items-baseline gap-[0.9vw]" data-id="element-172" data-mp="29pljsirjmy04">
              <p className="shrink-0 text-[clamp(18px,2.6vw,50px)] font-semibold leading-none tracking-[-0.03em] text-[#A26BFF]" data-id="element-173" data-mp="2ep7tii85xw46">
                {fact.value}
              </p>
              <p className={`${t.label} leading-[1.3] text-white/60`} data-id="element-174" data-mp="2ni1orp40963o">{fact.label}</p>
            </div>)}
        </Reveal>
      </div>
    </SlideFrame>;
}